export const getSingleBrand = _ref => {
  let {
    data
  } = _ref;
  return Object.keys(data)?.length === 1 && data?.manufacturers?.manufacturer?.length === 1 ? data.manufacturers.manufacturer?.[0] : undefined;
};